import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0404d9be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "features" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Features", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "headline" }, "All your social networks in one place", -1))
const _hoisted_4 = { class: "social-networks-showcase" }
const _hoisted_5 = { class: "social-network" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "headline" }, "Easy to use drag-and-drop website builder", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "headline" }, "Mobile friendly websites that work on all devices", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "headline" }, "Social media integration so you can share your site on Facebook, Twitter and Instagram", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "headline" }, [
  /*#__PURE__*/_createTextVNode("Let your audience get in touch with you using our Whatsapp "),
  /*#__PURE__*/_createElementVNode("b", null, "Message Me"),
  /*#__PURE__*/_createTextVNode(" button")
], -1))

import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from 'vue3-carousel'


export default /*#__PURE__*/_defineComponent({
  __name: 'FeaturesSection',
  setup(__props) {

const socialCarouselItems = [
  'facebook',
  'twitter',
  'instagram',
  'tiktok',
  'youtube',
  'spotify',
  'github',
  'linkedin',
  'dev',
  'steam',
  'pinterest',
  'dribbble',
  'soundcloud',
]

const socialBreakpoint = {
  700: {
    itemsToShow: 5
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Carousel), {
        autoplay: true,
        "items-to-show": 2,
        "wrap-around": true,
        transition: 4000,
        "snap-align": _ctx.center,
        breakpoints: socialBreakpoint
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socialCarouselItems, (item, index) => {
            return _createVNode(_unref(Slide), { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("i", {
                    class: _normalizeClass(`fa-brands fa-${item}`)
                  }, null, 2)
                ])
              ]),
              _: 2
            }, 1024)
          }), 64))
        ]),
        _: 1
      }, 8, ["snap-align"])
    ]),
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9
  ]))
}
}

})